/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Confirmnewpasswordplaceholder3Inputs */

const zh_auth_confirmnewpasswordplaceholder3 = /** @type {(inputs: Auth_Confirmnewpasswordplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请确认新密码`)
};

const en_auth_confirmnewpasswordplaceholder3 = /** @type {(inputs: Auth_Confirmnewpasswordplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm your new password`)
};

const es_auth_confirmnewpasswordplaceholder3 = /** @type {(inputs: Auth_Confirmnewpasswordplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirma tu nueva contraseña`)
};

/**
* | output |
* | --- |
* | "Confirm your new password" |
*
* @param {Auth_Confirmnewpasswordplaceholder3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_confirmnewpasswordplaceholder3 = /** @type {((inputs?: Auth_Confirmnewpasswordplaceholder3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Confirmnewpasswordplaceholder3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_confirmnewpasswordplaceholder3(inputs)
	if (locale === "en") return en_auth_confirmnewpasswordplaceholder3(inputs)
	return es_auth_confirmnewpasswordplaceholder3(inputs)
});
export { auth_confirmnewpasswordplaceholder3 as "auth_confirmNewPasswordPlaceholder" }